import { croAccountingConstants } from '../../_constants';

export function croAccounting(state = {}, action) {
    switch (action.type) {
        case croAccountingConstants.RESET:
            return {}
        case croAccountingConstants.CROACCOUNTING_FETCHING:
            return {
                ...state,
                croAccountingFetching: true
            };
        case croAccountingConstants.CROACCOUNTING_FETCHED:
            return {
                ...state,
                croAccountingFetching: false
            };
        case croAccountingConstants.CROACCOUNTING_SUBMITTING:
            return {
                ...state,
                croAccountingSubmitting: true
            };
        case croAccountingConstants.CROACCOUNTING_SUBMITTED:
            return {
                ...state,
                croAccountingSubmitting: false
            };
        case croAccountingConstants.GET_VOYAGE_LIST_CRO_ACCOUNTING: {
            return {
                ...state,
                voyageListCroAccounting: action.voyageListCroAccounting
            }
        }
        case croAccountingConstants.GET_WAYBILL_LIST_CRO_ACCOUNTING: {
            return {
                ...state,
                waybillListCroAccounting: action.waybillListCroAccounting
            }
        }
        case croAccountingConstants.GET_WAYBILL_CRO_ACCOUNTING: {
            return {
                ...state,
                waybillCroAccounting: action.waybillCroAccounting
            }
        }
        case croAccountingConstants.GET_CRO_ACCOUNTING_BY_ID: {
            return {
                ...state,
                CroById: action.CroById
            }
        }
        case croAccountingConstants.GET_VOYAGE_DESTINATION: {
            return {
                ...state,
                voyageDestination: action.voyageDestination
            }
        }
        case croAccountingConstants.GENERATE_WAYBILL_INVOICE: {
            return {
                ...state,
                waybillInvoice: action.waybillInvoice
            }
        }
        case croAccountingConstants.CRO_POST: {
            return {
                ...state,
                POSTCRO: action.POSTCRO
            }
        }
        // PDC clearing
        case croAccountingConstants.LOAD_PDC_COLLECTION: {
            return {
                ...state,
                pdcCollection: action.pdcCollection
            }
        }
        // BASE Manual SI
        case croAccountingConstants.MANUAL_SALES_INVOICE: {
            return {
                ...state,
                manualSI: action.manualSI
            }
        }
        case croAccountingConstants.MANUAL_SALES_INVOICE_OTHER: {
            return {
                ...state,
                manualSIOther: action.manualSIOther
            }
        }
        default:
            return state;
    }
}